import React from "react";
import { getImgPath } from "../common/helper";
import {
  t,
  TAB1_HEADING1,
  TAB1_HEADING2,
  TAB1_LI1,
  TAB1_LI2,
  TAB1_LI3,
  TAB1_LI4,
  TAB1_LI4_1,
  TAB1_LI4_2,
  TAB1_P1,
} from "../../translations/AboutUs/BusServiceFlybus";

import { tAboutUsCommon, CLICK_HERE } from "../../translations/AboutUs/Common";

function BusServiceFlybus() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <div style={{ fontSize: 20, fontWeight: 600, textAlign: "left" }}>
        {t(TAB1_HEADING1)}
      </div>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <div>
          <img src={getImgPath("/img/aboutus/bus_service/bus3.png")} alt="" />
        </div>
      </div>
      <div style={{ fontSize: 16, fontWeight: 600, textAlign: "left" }}>
        {t(TAB1_HEADING2)}
      </div>
      <div>
        <ul style={{ margin: 0, padding: 0, marginLeft: 48 }}>
          <li style={{ fontSize: "14px", fontWeight: 400 }}>{t(TAB1_LI1)}</li>
          <li style={{ fontSize: 14, fontWeight: 400 }}>{t(TAB1_LI2)}</li>
          <li style={{ fontSize: 14, fontWeight: 400 }}>{t(TAB1_LI3)}</li>
          <li style={{ fontSize: 14, fontWeight: 400 }}>
            {t(TAB1_LI4_1)}{" "}
            <a href="" style={{ color: "#004f9e" }}>
              {tAboutUsCommon(CLICK_HERE)}
            </a>{" "}
            {t(TAB1_LI4_2)}
          </li>
        </ul>
      </div>
      <div style={{ fontSize: 16, fontWeight: 600, textAlign: "left" }}>
        {t(TAB1_P1)}{" "}
        <a href="" style={{ color: "#004f9e", textTransform: "uppercase" }}>
          {tAboutUsCommon(CLICK_HERE)}
        </a>
      </div>
    </div>
  );
}

export default BusServiceFlybus;
